import React, { useEffect, useMemo } from 'react';
import { useWizard } from '@leverege/ui-wizard';
import I18N from '@leverege/i18n';
import { Flex, Pane, Text } from '@leverege/ui-elements';
import { ItemCard } from '@leverege/ui-attributes';
import S from './AssetPaired.css';
import Util from "./Util.js";
const {
  t,
  tIcon
} = I18N.ns('pairing.imagine.TagPaired');
export default function TagPaired(props) {
  const {
    context,
    setHeader,
    setHeaderIcon,
    setNextText,
    activeStep,
    wizardData
  } = useWizard();
  const {
    relationship,
    parentRelationship
  } = context;
  const assetName = relationship.parentBlueprint.name;
  const tagName = relationship.blueprint.name;
  const tag = wizardData?.tag?.obj;
  const asset = wizardData?.asset?.obj;
  useEffect(() => {
    setHeader(t('header', {
      tagName,
      assetName
    }));
    setHeaderIcon(tIcon('headerIcon'));
    setNextText(t('override'));
  }, []);
  const extraRenderers = useMemo(() => {
    let extraFields = activeStep?.extraFields;
    if (!extraFields) {
      extraFields = [{
        name: 'name'
      }];
    }
    const model = Util.getItemModelFromAttributes(extraFields, {
      objectType: parentRelationship.objectType
    });
    return /*#__PURE__*/React.createElement(ItemCard, {
      model: model,
      context: {
        target: [{
          ...asset,
          data: {
            ...asset?.data
          }
        }]
      }
    });
  }, [activeStep, asset, parentRelationship]);
  return /*#__PURE__*/React.createElement(Flex, {
    variant: "colL"
  }, activeStep.image && /*#__PURE__*/React.createElement("img", {
    className: S.pairImage,
    src: activeStep.image.src,
    alt: activeStep.image.alt,
    height: activeStep.image.height || 136,
    width: activeStep.image.width || 136
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "formTitleCenter"
  }, t('title', {
    tagName
  })), /*#__PURE__*/React.createElement(Text, null, t('description', {
    assetName,
    tagName
  })), extraRenderers && /*#__PURE__*/React.createElement(Pane, {
    layout: "flex:colS",
    style: {
      marginTop: 10,
      '--color-detailEvenRow': 'transparent',
      '--color-detailOddRow': 'rgba(0, 0, 0, 0.03)'
    }
  }, /*#__PURE__*/React.createElement(Pane, {
    variant: "detailCardNoShadow"
  }, extraRenderers)));
}
TagPaired.TYPE = 'imagine.pairing.TagPaired';